import { isInternalTeramotEmail } from '@/model/user/user.model';
import { useAppSelector } from '@/shared/hooks/useStore';
import { useCreditsSummary } from '@/viewmodel/features/credits/hooks/useCreditsSummary';
import type { CreditsNavAccess } from '@/viewmodel/features/credits/types';
import { selectUserData } from '@/viewmodel/features/user';
import { selectCurrentWorkspace } from '@/viewmodel/features/workspace';

export function useCreditsNavViewModel(): CreditsNavAccess {
  const workspaceId = useAppSelector(selectCurrentWorkspace)?.id;
  const userEmail = useAppSelector(selectUserData).data?.email;
  const { summary } = useCreditsSummary(workspaceId);

  if (isInternalTeramotEmail(userEmail)) return 'internal';
  return summary !== null ? 'customer' : null;
}
